import {
  LOAD_PROPOSALS,
  LOAD_PROPOSALS_ERROR,
  LOAD_PROPOSALS_SUCCESS,
  CANCEL_PROPOSAL,
  CANCEL_NEW_OPERATIONS_PROPOSAL,
  CANCEL_NEW_OPERATIONS_PROPOSAL_SUCCESS,
  CANCEL_NEW_OPERATIONS_PROPOSAL_ERROR,
} from '../constants/proposals';


const PROPOSALS_INIT = {
  filters: [],
  proposals: [],
  loading: false,
  loadingError: false,
};

export default (state = PROPOSALS_INIT, action) => {
  switch (action.type) {
    case LOAD_PROPOSALS:
      return {
        ...state,
        loading: true,
        filters: action.payload || [],
      };

    case LOAD_PROPOSALS_SUCCESS:
      return {
        ...state,
        loading: false,
        proposals: action.proposals,
        filters:  state.filters.length > 0 ? state.filters : action.filters,
      };

    case LOAD_PROPOSALS_ERROR:
      return {
        ...state,
        loading: false,
        loadingError: true,
      };

    case CANCEL_PROPOSAL:
      return {
        ...state,
        loading: true,
      };

    case CANCEL_NEW_OPERATIONS_PROPOSAL:
      return {
        cancelationId: action.proposalId,
        loading: true,
        success: false,
        error: false,
      };
    case CANCEL_NEW_OPERATIONS_PROPOSAL_SUCCESS:
      return {
        cancelationId: action.proposalId,
        loading: false,
        success: true,
        error: false,
      };
    case CANCEL_NEW_OPERATIONS_PROPOSAL_ERROR:
      return {
        cancelationId: null,
        loading: false,
        success: false,
        error: true,
      };

    default:
      return state;
  }
};
